import { GET_MAINTENANCE_MODE } from "uniba-volto-manutenzione/actions";


const initialState = {
    error: null,
    items: [],
    total: 0,
    loaded: false,
    loading: false,
    batching: {},
    subrequests: {},
};

/**
 * querystringsearch reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function maintenanceModeReducer(state = initialState, action = {}) {
    switch (action.type) {
        case `${GET_MAINTENANCE_MODE}_PENDING`:
            return {
                ...state,
                loadingResults: true,
            };

        case `${GET_MAINTENANCE_MODE}_SUCCESS`:
            return {
                ...state,
                result: action.result,
                loadingResults: false,
            };

        case `${GET_MAINTENANCE_MODE}_FAIL`:
            return {
                ...state,
                error: action.error,
                hasError: true,
                loadingResults: false,
            };

        default:
            return state;
    }
};
